<template>
    <header class="content__header">
        <h2 class="content__title">{{ $t('words.program_schedule') }}</h2>
        <div class="content__subtitle">
            <div class="icon__wrapper">
                <i class="icon icon-info-circle-line"></i>
            </div>
            <span>{{ $t('words.program_hide_channel_info') }}</span>
        </div>
        <div class="content__header__action">
            <a class="btn btn__primary" @click="showRegisterModal">
                <i class="icon icon-sm icon-add"></i>
                <span>{{ $t('words.program_register') }}</span>
            </a>
        </div>
    </header>
</template>

<script>
export default {
    name: 'SchedulesHeader',
    methods: {
        showRegisterModal() {
            this.$emit('showRegisterModal');
        },
    },
};
</script>
